/* import { IProjectMacro1, IProjectMacro1WithInfo } from '../../MacRO1/store/project/projectSlice';
import { IChannelGeometryVerticalDropForm } from '../../Macro2/components/InputForm/ChannelGeometry/IChannelGeometry';
import { IWeirGeometrySlopedWeirForm, IWeirGeometrySteppedWeirForm, IWeirGeometryVerticalDropForm } from '../../Macro2/components/InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometrySlopedWeirForm, IWingsGeometrySteppedWeirForm, IWingsGeometryVerticalDropForm } from '../../Macro2/components/InputForm/WingsGeometry/IWingsGeometry'; */
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
import { IMacro2ProjectPutData, IMacro1ProjectPutData, IContainerYardProjectPutData, IDynamicProjectPutData } from '../IApiRequest';
import { IDesigner, IProject } from '../IApiResponse';
/* import { serializeTemplateMacro2Request, serializeTemplateRequest } from '../utils'; */
import BeMaccaferriStoreProvider from './BeMaccaferriStoreProvider';
import { hasResponse } from '../../utils/typeGuards';

export const getCountryByCoordinatesAsync = async (latitude: number, longitude: number) => BeMaccaferriStoreProvider.getCountryByCoordinates(latitude, longitude);

export const getAvailableGeogridFamiliesAsync = async (countryCode: string) => BeMaccaferriStoreProvider.getAvailableGeogridFamiliesAsync(countryCode);

//PROJECT------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getProjectsByDesignerAsync = async (designer: number, pageNumber: number, pageSize: number) => BeMaccaferriStoreProvider.getProjectsByDesignerAsync(designer, pageNumber, pageSize);

export const getProjectsAsync = async (pageNumber: number, pageSize: number) => BeMaccaferriStoreProvider.getProjectsAsync(pageNumber, pageSize);

export const getProjectCountriesAsync = async (countryName?: string) => BeMaccaferriStoreProvider.getProjectCountriesAsync(countryName);
export const getProjectSiteEnvLevelAsync = async (lang?: string) => BeMaccaferriStoreProvider.getProjectSiteEnvLevelsAsync(lang);

export const projectAvailableByAuthorAsync = async (id: number, author: string) => BeMaccaferriStoreProvider.projectAvailableByAuthorAsync(id, author);

export const getProjectBaseAsync = async (id: number) => BeMaccaferriStoreProvider.getProjectBaseAsync(id);

export const getMacro1ProjectByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getMacro1ProjectByIdAsync(id);

//export const getMacro2ProjectByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getMacro2ProjectByIdAsync(id);
export const getContainerYardProjectAsync = async (id: string) => BeMaccaferriStoreProvider.getContainerYardProjectAsync(id);

export const putContainerYardProjectAsync = async (projectData: IContainerYardProjectPutData) => BeMaccaferriStoreProvider.putContainerYardProjectAsync(projectData);
export const putDynamicProjectAsync = async (projectData: IDynamicProjectPutData) => BeMaccaferriStoreProvider.putDynamicProjectAsync(projectData);

export const getMacro1ProjectAsync = async (id: string) => BeMaccaferriStoreProvider.getMacro1ProjectAsync(id);

export const getDynamicProjectAsync = async (id: string) => BeMaccaferriStoreProvider.getDynamicProjectAsync(id);

export const putMacro1ProjectAsync = async (projectData: IMacro1ProjectPutData) => BeMaccaferriStoreProvider.putMacro1ProjectAsync(projectData);

export const getMacro2ProjectAsync = async (id: string) => BeMaccaferriStoreProvider.getMacro2ProjectAsync(id);

export const putMacro2ProjectAsync = async (projectData: IMacro2ProjectPutData) => BeMaccaferriStoreProvider.putMacro2ProjectAsync(projectData);

export const deleteProjectByIdAsync = async (id: number) => BeMaccaferriStoreProvider.deleteProjectByIdAsync(id);

export const saveMaccaProjectAsync = async (project: IProject) => {
    return BeMaccaferriStoreProvider.saveMaccaProjectAsync(project);
};

export const addProjectAsync = async (project: IProject) => {
    return BeMaccaferriStoreProvider.addProjectAsync(project);
};

export const updateMaccaProjectAsync = async (project: IProject) => {
    return BeMaccaferriStoreProvider.updateMaccaProjectAsync(project);
};

export const putProjectAsync = async (projectInfo: IProjectInfoForm) => {
    return BeMaccaferriStoreProvider.putProjectAsync(projectInfo);
};

const handleDesignerAsync = async (projectInfo: IProjectInfoForm) => {
    try {
        return await getDesignerByNameAsync(projectInfo.designerFirmName);
    } catch (error: unknown) {
        if (hasResponse(error) && error.response.status == 404) {
            const designerPayload: IDesigner = {
                name: projectInfo.designerFirmName,
                country: projectInfo.designerFirmCountry,
                city: projectInfo.designerFirmCity,
            };
            try {
                await addDesignerAsync(designerPayload);
                return await getDesignerByNameAsync(projectInfo.designerFirmName);
            } catch (addError) {
                throw addError;
            }
        }
        throw error; // Re-throw other errors
    }
};

//COMPANY------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getDesignerByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getDesignerByIdAsync(id);

export const getDesignerByNameAsync = async (designerName: string) => BeMaccaferriStoreProvider.getDesignerByNameAsync(designerName);

export const addDesignerAsync = async (designer: IDesigner) => BeMaccaferriStoreProvider.addDesignerAsync(designer);

//blob
export const getAllDocumentsAsync = async () => BeMaccaferriStoreProvider.getAllDocumentsAsync();

export const uploadDocumentAsync = async (payload: FormData) => BeMaccaferriStoreProvider.uploadDocumentAsync(payload);

export const deleteDocumentAsync = async (name: string) => BeMaccaferriStoreProvider.deleteDocumentAsync(name);

//auth------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

export const generateToken = async () => BeMaccaferriStoreProvider.generateToken();
